export const TICKET_STATUS = {
	PENDING: 0,
	CONFIRMED: 1,
	CHECKED_IN: 2,
	CLOSED: 3,
	CANCELLED: 4,
	NO_SHOW: 5,
	DENIED: 6,
} as const;
export type TTicketStatus = typeof TICKET_STATUS[keyof typeof TICKET_STATUS];
